import React from "react";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { red } from "@material-ui/core/colors";

const theme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: red
  }
});

export default ({ children }) => (
  <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
);



// WEBPACK FOOTER //
// ./src/components/ThemeProvider.js